"use client";

import { TranslationsProvider } from "../../lib/hooks/useTranslations";
import BudgetCheck from "../BudgetCheck";

export interface EmbeddedBudgetCheckProps {
  hasExplicitOptIn?: boolean;
  locale: "en" | "de" | "immo";
}

const EmbeddedBudgetCheck = ({
  locale,
  hasExplicitOptIn = false,
}: EmbeddedBudgetCheckProps) => {
  return (
    <TranslationsProvider locale={locale}>
      <BudgetCheck hasExplicitOptIn={hasExplicitOptIn} />
    </TranslationsProvider>
  );
};

export default EmbeddedBudgetCheck;
